<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <h2 v-text="this.editing ? this.titulo : 'Nueva'"></h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col>
                    <v-text-field v-model="currentUtilidad.nombre" :rules="[(v) => !!v || 'Nombre es necesario']"
                        label="Nombre" required>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row align="center">
                <v-col align="center">
                    <v-btn v-if="this.editing" color="error" class="mr-2" @click="deleteUtilidad">
                        Borrar
                    </v-btn>

                    <v-btn v-if="this.editing" color="success" @click="updateUtilidad">
                        Actualizar
                    </v-btn>

                    <v-btn v-if="!this.editing" color="success" @click="saveUtilidad">
                        Guardar
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="this.editing">
                <v-col>
                    <template>
                        <v-data-table v-if="currentUtilidad.utilidad_base" :headers="tabla_bases"
                            :items="currentUtilidad.utilidad_base" class="elevation-1" :items-per-page="-1"
                            hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Bases relacionadas</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_base.cod_base="{ item }">
                                <router-link :to="'/bases/' + item.cod_base.cod_base">
                                    {{ item.cod_base.cod_base }}
                                </router-link>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
                <v-col>
                    <template>
                        <v-data-table v-if="currentUtilidad.utilidad_aditivo" :headers="tabla_aditivos"
                            :items="currentUtilidad.utilidad_aditivo" class="elevation-1" :items-per-page="-1"
                            hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Aditivos relacionados</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_aditivo.cod_aditivo="{ item }">
                                <router-link :to="'/aditivos/' + item.cod_aditivo.cod_aditivo">
                                    {{ item.cod_aditivo.cod_aditivo }}
                                </router-link>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import UtilidadesDataService from "@/services/UtilidadesDataService";

export default {
    name: "UtilidadId",
    props: ['id'],
    data() {
        return {
            editing: false,
            titulo: "",
            currentUtilidad: {
                id_utilidad: 0,
                nombre: "",
            },
            tabla_aditivos: [
                { text: "Codigo", value: "cod_aditivo.cod_aditivo" },
                { text: "Descripción", value: "cod_aditivo.descripcion" },
            ],
            tabla_bases: [
                { text: "Codigo", value: "cod_base.cod_base" },
                { text: "Descripción", value: "cod_base.descripcion" },
            ],
        };
    },
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        getUtilidad(id) {
            UtilidadesDataService.get(id)
                .then((response) => {
                    this.currentUtilidad = response.data;
                    this.titulo = this.currentUtilidad.nombre;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        updateUtilidad() {
            UtilidadesDataService.update(this.currentUtilidad.id_utilidad, this.currentUtilidad)
                .then((response) => {
                    this.setSnack({ message: "Actualizado correctamente", color: "success" });
                    this.$router.push({ name: "UtilidadesList" });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        deleteUtilidad() {
            UtilidadesDataService.delete(this.currentUtilidad.id_utilidad)
                .then((response) => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.$router.push({ name: "UtilidadesList" });
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        saveUtilidad() {
            let data = {
                nombre: this.currentUtilidad.nombre,
            };
            UtilidadesDataService.create(data)
                .then((response) => {
                    this.setSnack({ message: "Creado correctamente", color: "success" });
                    this.$router.push({ name: "UtilidadesList" });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
    },
    mounted() {
        this.editing = false;
        if (this.$route.params.id) {
            this.getUtilidad(this.$route.params.id);
            this.editing = true;
        }
    },
    watch: {
        '$route.params.id'(newId, oldId) {
            this.editing = false;
            this.currentUtilidad = {
                id_utilidad: 0,
                nombre: "",
            };
        }
    }
};
</script>